import { SmallGroup } from '@sleepstation/components'
import { CopyParagraph } from '@sleepstation/components-copy'
import PropTypes from 'prop-types'
import React from 'react'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const Question = ({ title, body }) => (
  <SmallGroup title={title} isClose>
    <CopyParagraph>{body}</CopyParagraph>
  </SmallGroup>
)

Question.propTypes = {
  title: PropTypes.string.isRequired,
  body: PropTypes.string,
}

Question.defaultProps = {
  body: null,
}

export default Question
